//import { logger } from "@sentry/react";

const ENV = process.env.REACT_APP_ENV;

const TYPE_ENV = {
  LOCAL: "LOCAL",
  DEVELOPMENT: "DEVELOPMENT",
  PREPRODUCTION: "PREPRODUCTION",
  PRODUCTION: "PRODUCTION",
};

const logDebug = (file, func, params) => {
  if (![TYPE_ENV.PRODUCTION].includes(ENV)) {
    console.debug(file, func, params);
    /*
    logger.log(
      logger.fmt`${file} - ${func} - params: ${params}`,
      {
        file: file,
        func: func,
        params: params,
      }
    );
    */
  }
};

const logInfo = (file, func, params) => {
  if (![TYPE_ENV.PRODUCTION].includes(ENV)) {
    console.info(file, func, params);
    /*
    logger.info(
      logger.fmt`${file} - ${func} - params: ${params}`,
      {
        file: file,
        func: func,
        params: params,
      }
    );
    */
  }
};

const logWarn = (file, func, params) => {
  console.warn(file, func, params);
  /*
  logger.warn(
    logger.fmt`${file} - ${func} - params: ${params}`,
    {
      file: file,
      func: func,
      params: params,
    }
  );
  */
};

const logError = (file, func, params) => {
  console.error(file, func, params);
  /*
  logger.error(
    logger.fmt`${file} - ${func} - params: ${params}`,
    {
      file: file,
      func: func,
      params: params,
    }
  );
  */
};

export { logDebug, logInfo, logWarn, logError, TYPE_ENV };
